const NATIONAL_DOCUMENT = 'NATIONAL_DOCUMENT'
const RESIDENT_DOCUMENT = 'RESIDENT_DOCUMENT'
const PASSPORT_DOCUMENT = 'PASSPORT_DOCUMENT'
const OTHER_DOCUMENT = 'OTHER_DOCUMENT'

module.exports = {
    NATIONAL_DOCUMENT,
    RESIDENT_DOCUMENT,
    PASSPORT_DOCUMENT,
    OTHER_DOCUMENT
};